
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="not-found-page">
      <div className="nf-container">
        <div className="nf-visual">
          <div className="nf-orbit nf-orbit-one" />
          <div className="nf-orbit nf-orbit-two" />

          <div className="nf-error-code">
            <span>4</span>
            <div className="nf-terminal">
              <div className="nf-terminal-top">
                <i />
                <i />
                <i />
              </div>
              <div className="nf-terminal-screen">
                <span className="nf-terminal-brand">NAVOI ETM</span>
                <span className="nf-terminal-symbol">?</span>
                <span className="nf-terminal-status">PAGE NOT FOUND</span>
              </div>
              <div className="nf-terminal-base" />
            </div>
            <span>4</span>
          </div>

          <span className="nf-floating nf-float-one">404_ERROR</span>
          <span className="nf-floating nf-float-two">SYSTEM ONLINE</span>
          <span className="nf-floating nf-float-three">NAVOI · UZ</span>
        </div>

        <div className="nf-content">
          <span className="nf-eyebrow">
            <span className="nf-status-dot" />
            XATOLIK KODI: 404
          </span>

          <h1>
            Sahifa
            <br />
            <span>topilmadi.</span>
          </h1>

          <p>
            Siz izlayotgan sahifa mavjud emas, manzili o‘zgargan
            yoki vaqtincha ochilmayapti. Keling, kerakli joyga qaytamiz.
          </p>

          <div className="nf-actions">
            <Link to="/" className="nf-button nf-button-primary">
              <span aria-hidden="true">⌂</span>
              Bosh sahifaga qaytish
              <span aria-hidden="true">↗</span>
            </Link>

            <Link to="/Products" className="nf-button nf-button-secondary">
              Mahsulotlarni ko‘rish
            </Link>
          </div>

          <div className="nf-help">
            <span className="nf-help-icon">i</span>
            <span>Muammo davom etsa, biz bilan bog‘laning.</span>
            <Link to="/Contact">Aloqa ↗</Link>
          </div>
        </div>
      </div>
    </main>
  );
}
